import styled from 'styled-components'

import type { CardProps } from './Card.types'

const StCard = styled.div<Omit<CardProps, 'children'>>`
  width: 100%;
  border-radius: ${({ theme }) => theme.UI.BorderRadius.Large}px;
  padding: ${({ theme }) => theme.UI.SpacingPx.Space4};
  position: relative;

  ${({ active, disabled, onClick, theme }) => {
    if (disabled) {
      return `
        background-color: ${theme.Components.Card.DisabledFill};
        border: 1px solid ${theme.Components.Card.DisabledBorder};
        color: ${theme.Components.Card.DisabledText};
      `
    }

    if (active) {
      return `
        background-color: ${theme.Components.Card.ActiveFill};
        border: 1px solid ${theme.Components.Card.ActiveBorder};
        color: ${theme.Components.Card.ActiveText};
      `
    }
    if (onClick) {
      return `
        background-color: ${theme.Components.Card.Fill};
        border: 1px solid ${theme.Components.Card.Border};
        color: ${theme.Components.Card.Text};
        cursor: pointer;
        &:hover {
          background-color: ${theme.Components.Card.ActiveFill};
          border: 1px solid ${theme.Components.Card.ActiveBorder};
          color: ${theme.Components.Card.ActiveText};
        }
      `
    }

    return `
      background-color: ${theme.Components.Card.Fill};
      border: 1px solid ${theme.Components.Card.Border};
      color: ${theme.Components.Card.Text};
    `
  }}
`

export { StCard }
